
<div class="header-toolbar">
  <h1 *ngIf="mode === 'edit' || mode === 'new'">{{ title }}</h1>
  <h1 *ngIf="mode === 'view'">{{ document?.name }}</h1>
</div>


<form #form="ngForm" (ngSubmit)="save()" autocomplete="off" *ngIf="document">

  <!-- Toolbar -->
  <div *ngIf="mode === 'edit' || mode === 'new'" class="main btn-toolbar">
        
    <button class="btn" type="submit" [disabled]="!document.valid">
      <t-icon name="check"></t-icon>
      <span class="text">Enregistrer</span>
    </button>

    &nbsp;

    <a class="btn" (click)="cancel()">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>

  <div *ngIf="mode === 'view' && revision.status === 'DRAFT'" class="main btn-toolbar">
        
    <div class="btn-group">    
      <div class="content">
        
        <a class="btn" [routerLink]="['edit']">
          <t-icon name="mode_edit"></t-icon>
          <span class="text">Modifier</span>
        </a>
        <button class="btn" (click)="delete()">
          <t-icon name="delete"></t-icon>
          <span class="text">Supprimer</span>
        </button>

      </div>
    </div>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="document">

    <div class="column">

      <div *ngIf="mode === 'edit' || mode === 'new'" class="panel">
        <h2>Document</h2>

        <div class="form-group">
          <label for="name">Nom</label>
          <input id="name" type="text" placeholder="" [formControl]="name" maxlength="200"/>
          <span class="info info-error" [hidden]="name.valid || name.pristine || !name.errors.required">Ce champ est requis</span>
        </div>

        <div class="form-group">
          <label for="target">Cible(s)</label>
          <t-select [items]="dossierModel.targets" [(item)]="document.target"></t-select>
        </div>

        <div class="form-group">
          <label for="file">Fichier modèle</label>
          <span class="value">{{ document.filename || '-' }}</span>
          <label class="file-select"
            ng2FileDrop
            (fileOver)="isFileOver = $event"
            [uploader]="uploader"
            [ngClass]="{ 'over': isFileOver }"
            for="file"
            >
            <t-icon name="attachment"></t-icon>
            <span class="text">Joindre un nouveau fichier</span>
          </label>
          <input id="file" type="file" style="display: none" ng2FileSelect [uploader]="uploader" />
        </div>

      </div>

      <div *ngIf="mode === 'view'" class="panel">
        <h2>Document</h2>

        <div class="form-group">
          <label for="name">Nom</label>
          <span id="name" class="value">{{ document.name }}</span>
        </div>

        <div class="form-group">
          <label for="target">Cible(s)</label>
          <span id="target" class="value">{{ dossierModel.getTargetLabel(document.target) }}</span>
        </div>

        <div class="form-group">
          <label for="filename">Fichier modèle</label>
          <span id="filename" class="value">
            {{ document.filename }}
          </span>
          <a class="file-download"
            title="Télécharger"
            href="{{ '/files/documents/' + operation.id + '/' + revision.id + '/' + document.id }}">
            <t-icon name="file_download"></t-icon>
          </a>
        </div>
      </div>
      
      <div *ngIf="mode === 'edit' || mode === 'view'" class="panel">
        <h2>Autres</h2>

        <div class="form-group">
          <label for="id">Identifiant</label>
          <span id="id" class="value">{{ document.id }}</span>
        </div>

        <div class="form-group">
          <label for="created_at">Date d'ajout</label>
          <span id="created_at" class="value">{{ document.created_at | tzdate }}</span>
        </div>

        <div class="form-group">
          <label for="created_by">Ajouté par</label>
          <span id="created_by" class="value">{{ document.created_by.fullname }}</span>
        </div>

        <div class="form-group">
          <label for="created_at">Date de modification</label>
          <span id="created_at" class="value">{{ document.updated_at | tzdate }}</span>
        </div>

        <div class="form-group">
          <label for="updated_by">Modifié par</label>
          <span id="updated_by" class="value">{{ document.updated_by.fullname }}</span>
        </div>
      </div>
      
    </div>

    <div class="column">

      <table *ngIf="documentErrors">
        <thead>
          <tr>
            <th>Erreur</th>
            <th>Balise</th>
            <th>Section</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let error of documentErrors">
            <td name="Erreur" style="width: 170px">{{ ERROR_TYPE[error.type] }}</td>
            <td name="Balise"><code>{{ '\{\{' + error.text + '\}\}' }}</code></td>
            <td name="Section" style="width: 170px">{{ SECTION_NAME[error.section] }}</td>
          </tr>
        </tbody>
      </table>

      <table *ngIf="mode === 'edit' || mode === 'view'">
        <thead>
          <tr>
            <th>Champ</th>
            <th>Type</th>
            <th>Commentaire</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let field of document.fields">
            <td name="Champ">{{ field.text }}</td>
            <td name="Type">{{ field.isBoolean ? 'Oui/Non' : 'Texte' }}</td>
            <td name="Commentaire">{{ field.comment }}</td>
          </tr>
        </tbody>
      </table>

    </div>

  </div>
</form>